import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';

import { trackByValue, NgTemplateAssertType } from '@recruitee/common';
import { TranslatePipe } from '@recruitee/i18n';
import { Currency } from '@recruitee/pricing-types';
import { BillingPlanTier } from '@recruitee/products-types';
import {
  RtPlanButtonVariant,
  IconComponent,
  IconColorDirective,
  PlanButtonComponent,
  HeadingComponent,
  DividerComponent,
} from '@recruitee/user-interface';

import { JobSlotsLimitMessageComponent } from '../../job-slots-limit-message/job-slots-limit-message.component';
import { JobSlotsPickerComponent } from '../../job-slots-picker/job-slots-picker.component';
import { PlanPickerProductCtaLabelPipe } from '../plan-picker-product-cta-label.pipe';
import { PlanPickerProductHeaderComponent } from '../plan-picker-product-header/plan-picker-product-header.component';
import { PlanPickerProductPriceComponent } from '../plan-picker-product-price/plan-picker-product-price.component';
import { PlanPickerAnalytics } from '../plan-picker.analytics';
import { PlanPickerModel } from '../plan-picker.model';
import { PlanPickerProduct, PlanPickerState } from '../plan-picker.types';

@Component({
  selector: 'rt-plan-picker-products',
  templateUrl: './plan-picker-products.component.html',
  styleUrls: ['./plan-picker-products.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgTemplateOutlet,
    DividerComponent,
    NgTemplateAssertType,
    PlanPickerProductHeaderComponent,
    PlanPickerProductPriceComponent,
    HeadingComponent,
    JobSlotsPickerComponent,
    JobSlotsLimitMessageComponent,
    PlanButtonComponent,
    IconColorDirective,
    IconComponent,
    TranslatePipe,
    PlanPickerProductCtaLabelPipe,
  ],
})
export class PlanPickerProductsComponent {
  public readonly templateTypeProduct: { $implicit: PlanPickerProduct };
  public readonly Currency = Currency;
  public readonly BillingPlanTier = BillingPlanTier;

  @Output() public selected = new EventEmitter<PlanPickerProduct>();
  @Output() public slotsChange = new EventEmitter<{ codename: BillingPlanTier; value: number }>();
  @Output() public cancelSubscription = new EventEmitter<void>();

  @Input() public state: PlanPickerState;

  public trackByFeature = trackByValue;

  public planTierButtonVariantMap: Record<BillingPlanTier, RtPlanButtonVariant> = {
    [BillingPlanTier.Launch]: 'launch',
    [BillingPlanTier.Scale]: 'scale',
    [BillingPlanTier.Lead]: 'lead',
    [BillingPlanTier.Start]: 'start',
    [BillingPlanTier.Grow]: 'grow',
    [BillingPlanTier.Optimize]: 'optimize',
  };

  constructor(
    public content: PlanPickerModel,
    public analytics: PlanPickerAnalytics,
  ) {}

  public trackByProduct(index: number, { codename, product }: PlanPickerProduct) {
    return `${codename}#${product?.id}`;
  }

  public trackByRef(index: number, ref: TemplateRef<any>) {
    return ref;
  }
}
